"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thorchain = void 0;
const common_1 = require("./common");
class Thorchain {
    constructor(transport, scrambleKey = common_1.APP_KEY) {
        if (!transport) {
            throw new Error("Transport has not been defined");
        }
        this.transport = transport;
        transport.decorateAppAPIMethods.bind(transport)(this, ["getAddress", "sign"], scrambleKey);
    }
    getVersion() {
        return this.transport.send(common_1.CLA, common_1.INS.GET_VERSION, 0, 0).then((response) => {
            const errorCodeData = response.slice(-2);
            const returnCode = errorCodeData[0] * 256 + errorCodeData[1];
            let targetId = 0;
            if (response.length >= 9) {
                targetId = (response[5] << 24) + (response[6] << 16) + (response[7] << 8) + (response[8] << 0);
            }
            return {
                return_code: returnCode,
                error_message: (0, common_1.errorCodeToString)(returnCode),
                test_mode: response[0] !== 0,
                major: response[1],
                minor: response[2],
                patch: response[3],
                device_locked: response[4] === 1,
                target_id: targetId.toString(16),
            };
        }, common_1.processErrorResponse);
    }
    serializeHRP(hrp) {
        if (hrp == null || hrp.length === 0 || hrp.length > 83) {
            throw new Error("Invalid HRP");
        }
        const buf = Buffer.alloc(1 + hrp.length);
        buf.writeUInt8(hrp.length, 0);
        buf.write(hrp, 1);
        return buf;
    }
    serializePath(path) {
        return __awaiter(this, void 0, void 0, function* () {
            this.versionResponse = yield this.getVersion();
            if (this.versionResponse.return_code !== common_1.ErrorCode.NoError) {
                throw this.versionResponse;
            }
            switch (this.versionResponse.major) {
                case 2: {
                    if (!path || path.length !== 5) {
                        throw new Error("Invalid path.");
                    }
                    const buf = Buffer.alloc(20);
                    buf.writeUInt32LE(path[0], 0);
                    buf.writeUInt32LE(path[1], 4);
                    buf.writeUInt32LE(path[2], 8);
                    buf.writeUInt32LE(path[3], 12);
                    buf.writeUInt32LE(path[4], 16);
                    return buf;
                }
                default:
                    return {
                        return_code: 0x6400,
                        error_message: "App Version is not supported",
                    };
            }
        });
    }
    getAddress(path, hrp, boolDisplay) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.serializePath(path)
                    .then((serializedPath) => {
                    if (!Buffer.isBuffer(serializedPath))
                        return serializedPath;
                    const data = Buffer.concat([this.serializeHRP(hrp), serializedPath]);
                    return this.transport
                        .send(common_1.CLA, common_1.INS.GET_ADDR_SECP256K1, boolDisplay ? common_1.P1_VALUES.SHOW_ADDRESS_IN_DEVICE : common_1.P1_VALUES.ONLY_RETRIEVE, 0, data, [common_1.ErrorCode.NoError])
                        .then((response) => {
                        const errorCodeData = response.slice(-2);
                        const return_code = errorCodeData[0] * 256 + errorCodeData[1];
                        return {
                            address: Buffer.from(response.slice(33, -2)).toString(),
                            publicKey: Buffer.from(response.slice(0, 33)).toString("hex"),
                            return_code,
                            error_message: (0, common_1.errorCodeToString)(return_code),
                        };
                    }, common_1.processErrorResponse);
                })
                    .catch((err) => (0, common_1.processErrorResponse)(err));
            }
            catch (e) {
                return (0, common_1.processErrorResponse)(e);
            }
        });
    }
    signGetChunks(path, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const serializedPath = yield this.serializePath(path);
            if (!Buffer.isBuffer(serializedPath))
                return serializedPath;
            const chunks = [];
            chunks.push(serializedPath);
            const buffer = Buffer.from(message);
            for (let i = 0; i < buffer.length; i += common_1.CHUNK_SIZE) {
                let end = i + common_1.CHUNK_SIZE;
                if (i > buffer.length) {
                    end = buffer.length;
                }
                chunks.push(buffer.slice(i, end));
            }
            return chunks;
        });
    }
    signSendChunk(chunkIdx, chunkNum, chunk) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.versionResponse.major) {
                case 2: {
                    chunkIdx = (() => {
                        if (chunkIdx === 1)
                            return common_1.PAYLOAD_TYPE.INIT;
                        if (chunkIdx === chunkNum)
                            return common_1.PAYLOAD_TYPE.LAST;
                        return common_1.PAYLOAD_TYPE.ADD;
                    })();
                    return this.transport
                        .send(common_1.CLA, common_1.INS.SIGN_SECP256K1, chunkIdx, 0, chunk, [common_1.ErrorCode.NoError, 0x6984, 0x6a80])
                        .then((response) => {
                        const errorCodeData = response.slice(-2);
                        const returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        let errorMessage = (0, common_1.errorCodeToString)(returnCode);
                        if (returnCode === 0x6a80 || returnCode === 0x6984) {
                            errorMessage = `${errorMessage} : ${response.slice(0, response.length - 2).toString("ascii")}`;
                        }
                        let signature = null;
                        if (response.length > 2) {
                            signature = response.slice(0, response.length - 2);
                        }
                        return {
                            signature,
                            return_code: returnCode,
                            error_message: errorMessage,
                        };
                    }, common_1.processErrorResponse);
                }
                default:
                    return {
                        signature: null,
                        return_code: 0x6400,
                        error_message: "App Version is not supported",
                    };
            }
        });
    }
    sign(path, message) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.signGetChunks(path, message).then((chunks) => {
                if (!Array.isArray(chunks))
                    return chunks;
                return this.signSendChunk(1, chunks.length, chunks[0]).then((response) => __awaiter(this, void 0, void 0, function* () {
                    let result = {
                        return_code: response.return_code,
                        error_message: response.error_message,
                        signature: null,
                    };
                    for (let i = 1; i < chunks.length; i += 1) {
                        result = yield this.signSendChunk(1 + i, chunks.length, chunks[i]);
                        if (result.return_code !== common_1.ErrorCode.NoError) {
                            break;
                        }
                    }
                    return {
                        return_code: result.return_code,
                        error_message: result.error_message,
                        signature: result.signature,
                    };
                }), common_1.processErrorResponse);
            }, common_1.processErrorResponse);
        });
    }
}
exports.Thorchain = Thorchain;
//# sourceMappingURL=hw-app-thor.js.map